// extracted by mini-css-extract-plugin
export default {"form":"CommentSection_form__PMCs2","profilePic":"CommentSection_profilePic__0v55E","btn":"CommentSection_btn__A0f9G"};